/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {DeliveryServiceVoModel} from '@well/domain';
import {EnvironmentService} from "@irian-ro/util-environment";
import { HttpClient } from '@angular/common/http';
import {QueryParams} from '@irian-ro/abstract-resource';
import { SelectableResourceService } from '@well/common-libs/selectable-resource-management/util';

@Injectable({
  providedIn: 'root'
})
export class DeliveryServiceVoResourceService extends SelectableResourceService<DeliveryServiceVoModel> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      `${environmentService.getEnvironmentProperty('deliveryServiceUrl')}/vos`,
      DeliveryServiceVoModel
    );
  }

  findAllFromServiceProvider(serviceProviderUuid: any, query: { filters: any }, additionalParams: any) {
    const queryString = new QueryParams(
      query,
      additionalParams ? additionalParams : []).toString();

    return this.httpClient?.get(`${this.url}/${serviceProviderUuid}${queryString}`).pipe(this.mapToListOfObjects());
  }
}
